import Flatpickr from 'stimulus-flatpickr'

export default class extends Flatpickr {
  change(_selectedDates, dateStr, _instance) {
    this.element.parentElement.querySelector(".datepicker-value").innerHTML = dateStr;
  }
}
